import styled, { css } from "styled-components";

const SwitchProfileButtonStyled = styled.button`
  	${props => (
		props.mobile &&
		css`
			background-color: rgba(114, 232, 240, 0.15);
			color: ${props => props.theme.teal};
			display: flex;
			align-items: center;
			border-radius: 0.5rem;
			padding: 1.2rem 1.6rem;
			margin-top: 0.5rem;
			margin-bottom: 1.6rem;
			font-size: 1.4rem;
			font-family: ${props => props.theme.fontBold};
			width: 100%;

			svg {
				margin-right: 1.6rem;
			}
		`
	)}

	${props => (
		props.mobile && props.isBusiness &&
		css`
			background-color: rgba(158, 216, 177, 0.1);
			color: ${props => props.theme.heritageGreen};
		`
	)}
`;

export default SwitchProfileButtonStyled;
